import styled from 'styled-components';
import { colors } from "../../styles/tokens";

export const ToggleButton = styled.div<{ isOn: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 80px;
  height: 40px;
  background-color: ${props => (props.isOn ? colors.primary : 'rgba(255, 255, 255, 0.3)')};
  border-radius: 25px;
  position: relative;
  transition: background-color 0.3s;
  padding: 5px;
  font-family: Arial, sans-serif;
  font-size: 16px;
`;

export const ToggleSlider = styled.div<{ isOn: boolean }>`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 30px;
  height: 30px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s;
  transform: ${props => (props.isOn ? 'translateX(40px)' : 'translateX(0)')};
`;

export const ToggleLabel = styled.span`
  color: white;
  font-weight: bold;
  position: absolute;
  left: 60px;
`;